import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-mail-01',
  imports: [],
  templateUrl: './mail-01.html',
  styleUrl: './mail-01.scss',
})
export class Mail01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
